// Libs
import React, { useMemo } from 'react';

// Constants
import { VIMEO_REGEX, YOUTUBE_REGEX } from '@/common/constants';
// Helpers
import getVideoSrc from '@/common/helpers/getVideoSrc';

import { VideoDefaultProps, VideoPropTypes } from './Video.proptypes';

const Video = ({ className, src, title }) => {
  const type = `video/${src.split('.').pop()}`;

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['video', className].filter((val) => val).join(' '),
    [className],
  );

  return (
    <div className={classNames} data-qa-id="slide-item">
      {src.match(VIMEO_REGEX) || src.match(YOUTUBE_REGEX) ? (
        <iframe
          src={getVideoSrc(src)}
          title={title}
          frameBorder="0"
          allowFullScreen
          data-qa-id="video"
        />
      ) : (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video controls>
          <source src={src} type={type} />
        </video>
      )}
    </div>
  );
};

Video.defaultProps = {
  ...VideoDefaultProps,
};

Video.propTypes = {
  ...VideoPropTypes,
};

export default Video;
